import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import type { MediaObjectMediaPropsInterface } from './types/media-object-media.types';

/**
 * @since 10.0.0
 */
export const MediaObjectMedia = forwardRef<HTMLDivElement, MediaObjectMediaPropsInterface>(
  (props: MediaObjectMediaPropsInterface, forwardedRef) => {
    const { asChild = false, className, css: cssProp, ...rest } = props;
    const Component = asChild ? Slot : 'div';
    return (
      <Component
        ref={forwardedRef}
        data-c11n-component="MediaObject.Media"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_media-object__media', css(cssProp), className)}
        {...rest}
      />
    );
  },
);

MediaObjectMedia.displayName = 'MediaObject.Media';
